module.exports = __webpack_public_path__ + "img/avatar.2d5390c1.jpeg";